<div class="master-management-container">
  
  <div class="content-container">
    
    <div class="table-toolbar">
      <div class="cyber-filter-group">
        <button class="cyber-chip" [class.active]="currentFilter === 'todos'" (click)="currentFilter = 'todos'">
          TODOS <span class="chip-count">{{allUsers.length}}</span>
        </button>
        <button class="cyber-chip" [class.active]="currentFilter === 'activo'" (click)="currentFilter = 'activo'">
          ACTIVOS <span class="chip-count" *ngIf="countActive > 0">{{countActive}}</span>
        </button>
        <button class="cyber-chip" [class.active]="currentFilter === 'inactivo'" (click)="currentFilter = 'inactivo'">
          INACTIVOS <span class="chip-count" *ngIf="countInactive > 0">{{countInactive}}</span>
        </button>
        <button class="cyber-chip pending" [class.active]="currentFilter === 'pendiente'" (click)="currentFilter = 'pendiente'">
          PENDIENTES <span class="notify-dot" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
        </button>
      </div>
      
      <button class="btn primary btn-glow" (click)="openModal('create')">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" style="margin-right: 6px;">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        NUEVO USUARIO
      </button>
    </div>

    <div *ngIf="isGlobalMode" style="background: rgba(255, 189, 46, 0.1); border: 1px dashed #ffbd2e; color: #a0aec0; padding: 12px 20px; margin-bottom: 20px; border-radius: 4px; font-family: monospace; font-size: 12px; display: flex; align-items: center; gap: 10px;">
      <span style="font-size: 16px;">⚡</span>
      <span style="color: #ffbd2e; font-weight: bold;">MODO GLOBAL:</span>
      <span>Mostrando únicamente personal de sistema. Seleccione un entorno activo en el menú superior para visualizar los datos de la operativa.</span>
    </div>

    <div class="surface list-container" style="flex: 1; padding: 0; display: flex; flex-direction: column;">
      <div class="table-scroll-area" style="border: none; border-radius: 0;">
        <table class="cyber-table">
          <thead>
            <tr>
              <th>USUARIO</th>
              <th>EMAIL</th>
              <th>ESTADO</th>
              <th>TOKENS (C / T)</th>
              <th style="text-align: right;">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of filteredUsers" 
                (click)="selectUser(user)" 
                [class.selected]="selectedUser?.id === user.id"
                [style.cursor]="user.estado === 'activo' ? 'pointer' : 'default'">
              
              <td><strong [style.color]="user.estado === 'activo' ? 'var(--dl-color-theme-primary1)' : 'var(--dl-color-theme-neutral-dark)'">{{ user.username }}</strong></td>
              <td>{{ user.email }}</td>
              <td>
                <span class="badge-status" [attr.data-status]="user.estado">{{ user.estado }}</span>
              </td>
              <td style="font-family: monospace;">{{ user.consumedtokens }} / {{ user.totaltokens || 0 }}</td>
              
              <td style="text-align: right;">
                <div class="action-buttons" [ngSwitch]="user.estado">
                  
                  <ng-container *ngSwitchCase="'activo'">
                    <button class="btn secondary sm" (click)="openModal('edit', user); $event.stopPropagation()">EDITAR</button>
                    <button class="btn secondary sm btn-outline-warning" (click)="deactivate(user, $event)">INACTIVAR</button>
                  </ng-container>

                  <ng-container *ngSwitchCase="'pendiente'">
                    <button class="btn primary sm" (click)="openModal('approve', user); $event.stopPropagation()">APROBAR</button>
                    <button class="btn danger sm" (click)="reject(user, $event)">DENEGAR</button>
                  </ng-container>

                  <ng-container *ngSwitchCase="'inactivo'">
                    <button class="btn primary sm btn-outline-success" (click)="openModal('activate', user); $event.stopPropagation()">ACTIVAR</button>
                    <button class="btn danger sm" (click)="delete(user, $event)">BORRAR</button>
                  </ng-container>

                </div>
              </td>
            </tr>
            <tr *ngIf="filteredUsers.length === 0">
              <td colspan="5" style="text-align: center; color: var(--dl-color-theme-neutral-dark); padding: 50px;">
                >_ Ningún usuario coincide con el filtro actual.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="right-drawer" *ngIf="selectedUser && selectedUser.estado === 'activo'" [class.collapsed]="!isRoleDrawerOpen">
    <div class="drawer-trigger" (click)="closeRoleDrawer()">
      <svg viewBox="0 0 24 24" [style.transform]="!isRoleDrawerOpen ? 'rotate(180deg)' : 'rotate(0deg)'">
        <path fill="currentColor" d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"></path>
      </svg>
      <span class="vertical-text" *ngIf="!isRoleDrawerOpen">CERRAR PANEL</span>
    </div>

    <div class="drawer-body" *ngIf="isRoleDrawerOpen">
      <div class="drawer-header" style="margin-bottom: 20px;">
        <span class="cyber-title">>_ ROLES: {{ selectedUser.username }}</span>
      </div>
      <app-user-role-manager [userId]="selectedUser.id"></app-user-role-manager>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showModal">
    <div class="surface modal-box">
      <h2 style="font-family: monospace; color: var(--dl-color-theme-primary1); margin-top: 0; margin-bottom: 20px;">
        >_ {{ modalTitle }}
      </h2>
      <p style="font-size: 12px; color: var(--dl-color-theme-neutral-dark); margin-top: -15px; margin-bottom: 25px;" *ngIf="modalMode === 'activate' || modalMode === 'approve'">
        Revise y complete los datos obligatorios para habilitar el acceso al sistema.
      </p>
      
      <form [formGroup]="userForm" (ngSubmit)="saveUser()" style="display: flex; flex-direction: column; gap: 15px;">
        <div style="display: flex; flex-direction: column;">
          <label class="modal-label">Usuario <span class="req">*</span></label>
          <input type="text" class="form-control" formControlName="username">
        </div>

        <div style="display: flex; flex-direction: column;">
          <label class="modal-label">Correo Electrónico <span class="req">*</span></label>
          <input type="email" class="form-control" formControlName="email">
        </div>

        <div style="display: flex; flex-direction: column;">
          <label class="modal-label">Contraseña <span *ngIf="modalMode === 'create'" class="req">*</span><span *ngIf="modalMode !== 'create'" style="color: #666; text-transform: none;"> (Vacío para no alterar actual)</span></label>
          <input type="password" class="form-control" formControlName="password">
        </div>

        <div style="display: flex; gap: 15px;">
          <div style="flex: 1; display: flex; flex-direction: column;">
            <label class="modal-label">Tokens Totales <span class="req">*</span></label>
            <input type="number" class="form-control" formControlName="totaltokens">
          </div>
          <div style="flex: 1; display: flex; flex-direction: column;">
            <label class="modal-label">Tokens Consumidos <span class="req">*</span></label>
            <input type="number" class="form-control" formControlName="consumedtokens">
          </div>
        </div>

        <ng-container *ngIf="isSuperAdminAppUser">
          <div style="display: flex; flex-direction: column; margin-top: 10px; padding-top: 15px; border-top: 1px solid var(--dl-color-theme-secondary1);">
            <label class="modal-label" style="color: var(--dl-color-theme-primary1);">
              Tenant Base <span class="req" *ngIf="!userForm.get('issuperadmin')?.value">*</span>
            </label>
            <select class="form-control" formControlName="tenantid">
              <option [ngValue]="null">SIN TENANT (Global / SuperAdmin)</option>
              <option *ngFor="let t of tenants" [value]="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
            <input type="checkbox" formControlName="issuperadmin" id="chkSuperAdmin" style="width: 16px; height: 16px;">
            <label for="chkSuperAdmin" style="font-size: 12px; color: #ff5f56; cursor: pointer; font-family: monospace;">Es SuperAdministrador</label>
          </div>
        </ng-container>

        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 25px;">
          <button type="button" class="btn secondary" (click)="closeModal()">CANCELAR</button>
          <button type="submit" class="btn primary" [disabled]="userForm.invalid">
            {{ modalMode === 'activate' || modalMode === 'approve' ? 'GUARDAR Y ACTIVAR' : 'GUARDAR' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>